import { render, staticRenderFns } from "./TestTransactionSetup.vue?vue&type=template&id=3a9a91d9&scoped=true"
import script from "./TestTransactionSetup.vue?vue&type=script&lang=js"
export * from "./TestTransactionSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a91d9",
  null
  
)

export default component.exports